var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	5724: {
		fallback: function() { return function() { return __webpack_require__(5723); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	3: {
		fallback: function() { return Promise.all([__webpack_require__.e(8369), __webpack_require__.e(8952), __webpack_require__.e(7029), __webpack_require__.e(5724), __webpack_require__.e(3517), __webpack_require__.e(7320)]).then(function() { return function() { return __webpack_require__(5781); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",
	},
	4922: {
		fallback: function() { return __webpack_require__.e(9337).then(function() { return function() { return __webpack_require__(1718); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	3938: {
		fallback: function() { return Promise.all([__webpack_require__.e(8369), __webpack_require__.e(8)]).then(function() { return function() { return __webpack_require__(8); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	4040: {
		fallback: function() { return Promise.all([__webpack_require__.e(8952), __webpack_require__.e(3517), __webpack_require__.e(91)]).then(function() { return function() { return __webpack_require__(7903); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	5368: {
		fallback: function() { return Promise.all([__webpack_require__.e(3867), __webpack_require__.e(3517), __webpack_require__.e(5236)]).then(function() { return function() { return __webpack_require__(6248); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	6280: {
		fallback: function() { return __webpack_require__.e(2369).then(function() { return function() { return __webpack_require__(7131); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	9065: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(2155); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	7438: {
		fallback: function() { return __webpack_require__.e(3160).then(function() { return function() { return __webpack_require__(3160); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",
	},
	9787: {
		fallback: function() { return __webpack_require__.e(1721).then(function() { return function() { return __webpack_require__(1721); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",
	},
	3134: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(8997); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	3517: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(316); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	2809: {
		fallback: function() { return __webpack_require__.e(9512).then(function() { return function() { return __webpack_require__(7131); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	7451: {
		fallback: function() { return Promise.all([__webpack_require__.e(8369), __webpack_require__.e(8), __webpack_require__.e(807)]).then(function() { return function() { return __webpack_require__(8); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	8171: {
		fallback: function() { return __webpack_require__.e(9337).then(function() { return function() { return __webpack_require__(1718); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	3249: {
		fallback: function() { return __webpack_require__.e(3867).then(function() { return function() { return __webpack_require__(6248); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [5724,3,4922,3938,4040,5368,6280,9065,7438,9787,5724,9065,3134,3517,8171,3,3249,2809,7451];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"3": [
		3
	],
	"553": [
		7451
	],
	"636": [
		8171,
		3,
		3249,
		2809,
		7451
	],
	"2809": [
		2809
	],
	"3517": [
		3517
	],
	"5527": [
		4922,
		3938,
		4040,
		5368,
		6280,
		9065,
		7438,
		9787
	],
	"5724": [
		5724
	],
	"8792": [
		5724,
		9065,
		3134,
		3517
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}